import axios from 'axios';
import {
  CreateOrderInput,
  CreateOrderResult,
} from 'views/order-feed/features/my-supply-plan/types/create-order-input.type';
import {
  EditOrderInput,
  EditOrderResult,
} from 'views/order-feed/features/my-supply-plan/types/edit-order-input.type';

// POST
export const postOrder = async (customerErpId: string, request: CreateOrderInput): Promise<CreateOrderResult> => {
  const res = await axios.post<string>(`/ewosapi/v1/order?customerErpId=${customerErpId}`, request);

  return { orderNumber: res.data, createOrderInput: request };
};

// PUT
export const putOrder = async (customerErpId: string, request: EditOrderInput): Promise<EditOrderResult> => {
  const res = await axios.put<string>(`/ewosapi/v1/order?customerErpId=${customerErpId}`, request);

  return { orderNumber: res.data, editOrderInput: request };
};